// Complete vehicle data for Urban Rent Car
export const vehiclesData = [
  {
    id: 'chevrolet-tahoe-2025-high-country',
    name: 'Chevrolet Tahoe High Country',
    year: 2025,
    category: 'luxury',
    categoryLabel: 'Luxury',
    price: 320,
    images: [
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/pmyj1u9j_tahoe%202025%201.jpeg',
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/ustn29yf_tahoe%202025%202.jpeg',
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/49h7zty8_tahoe%202025%203.jpeg',
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/0bfe18dn_tahoe%202025%204.jpeg'
    ],
    mainImage: 'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/pmyj1u9j_tahoe%202025%201.jpeg',
    description: 'Chevrolet Tahoe 2025 High Country en negro brillante. El SUV full-size más lujoso y exclusivo de toda la flota.',
    longDescription: 'La Chevrolet Tahoe 2025 High Country representa el pináculo del lujo americano en SUVs full-size. Este impresionante vehículo en negro brillante cuenta con la exclusiva parrilla cromada High Country, llantas premium de múltiples radios, y el distintivo emblema High Country. El interior es una obra maestra: asientos de cuero premium color café chocolate con el logo High Country bordado, tablero digital gigante de extremo a extremo, detalles en madera auténtica, techo panorámico masivo, y climatización de cuatro zonas. Con capacidad para 7 pasajeros en asientos tipo capitán, es perfecta para familias VIP o grupos ejecutivos que buscan el máximo lujo y espacio.',
    passengers: 7,
    luggage: 6,
    fuel: 'Gasolina',
    transmission: 'Automática 10 velocidades',
    features: [
      'Edición High Country más exclusiva',
      'Modelo 2025 completamente nuevo',
      'Asientos de cuero premium café chocolate',
      'Logo High Country bordado en asientos',
      'Tablero digital gigante de extremo a extremo',
      'Detalles en madera auténtica',
      'Techo panorámico masivo',
      'Parrilla cromada exclusiva High Country',
      'Llantas premium multi-radios',
      'Asientos capitán segunda fila',
      'Climatización de 4 zonas',
      'Sistema de sonido Bose premium',
      'Apple CarPlay / Android Auto inalámbrico',
      'Cámara 360° HD',
      'Head-up display',
      'Asientos eléctricos con memoria y ventilación',
      'Super Cruise (conducción semi-autónoma)',
      'Suspensión adaptativa magnética',
      'WiFi integrado',
      'Cargador inalámbrico',
      'Escapes cromados dobles'
    ],
    specifications: {
      motor: 'V8 6.2L EcoTec3',
      power: '420 HP',
      capacity: '7 pasajeros',
      cargo: '722 litros'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto',
      'Asistencia VIP 24/7',
      'GPS navegación premium',
      'Sillas para niños disponibles',
      'El vehículo más exclusivo de la flota'
    ],
    featured: true
  },
  {
    id: 'mercedes-gle-53-amg-2021-blanco',
    name: 'Mercedes-Benz GLE 53 AMG',
    year: 2021,
    category: 'luxury',
    categoryLabel: 'Luxury',
    price: 299,
    images: [
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/y7i51j8p_mercedes%201.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/h60v5tvb_mercedes%202.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/21janczj_mercedes%203.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/7g0v8gtp_mercedes%204.jpeg'
    ],
    mainImage: 'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/y7i51j8p_mercedes%201.jpeg',
    description: 'Mercedes-Benz GLE 53 AMG 2021 en blanco perla con techo negro. Lujo deportivo con diseño bicolor espectacular.',
    longDescription: 'Este impresionante Mercedes-Benz GLE 53 AMG 2021 en blanco perla con techo negro bicolor es la definición de elegancia deportiva. Cuenta con la icónica parrilla deportiva AMG Panamericana negra, llantas AMG negras, calipers de freno rojos, escapes deportivos cuádruples AMG y un interior de lujo con cuero negro, detalles en fibra de carbono y sistema MBUX con iluminación azul. Ideal para ejecutivos y turistas VIP que buscan destacar con estilo.',
    passengers: 5,
    luggage: 4,
    fuel: 'Gasolina Premium',
    transmission: 'Automática AMG Speedshift',
    features: [
      'Diseño bicolor blanco perla con techo negro',
      'Parrilla deportiva AMG Panamericana negra',
      'Llantas AMG negras exclusivas',
      'Calipers de freno rojos AMG',
      'Escapes deportivos cuádruples AMG',
      'Interior de cuero negro premium',
      'Tablero digital Mercedes MBUX con iluminación azul',
      'Detalles en fibra de carbono',
      'Sistema de sonido Burmester premium',
      'Cámara 360 grados',
      'Asientos con memoria y masaje',
      'Climatización de 3 zonas',
      'Estribos laterales cromados',
      'Techo panorámico',
      'Volante deportivo AMG con levas',
      'Suspensión neumática adaptativa',
      'AMG Performance exhaust'
    ],
    specifications: {
      motor: 'V6 3.0L Biturbo',
      power: '429 HP',
      acceleration: '0-100 km/h en 5.3s',
      topSpeed: '250 km/h (limitada)'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto SDQ',
      'Asistencia VIP 24/7',
      'GPS navegación premium',
      'Tanque lleno de gasolina premium',
      'Vehículo de lujo en estado impecable'
    ],
    featured: true
  },
  {
    id: 'mercedes-gle-53-amg-2021',
    name: 'Mercedes-Benz GLE 53 AMG',
    year: 2021,
    category: 'luxury',
    categoryLabel: 'Luxury',
    price: 299,
    images: [
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/ctxvi6n0_6.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/dii1d7lf_5.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/xpjgsmbh_7.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/0ub99bmt_8.jpeg'
    ],
    mainImage: 'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/ctxvi6n0_6.jpeg',
    description: 'Mercedes-Benz GLE 53 AMG 2021 en negro brillante. El máximo exponente de lujo y rendimiento deportivo.',
    longDescription: 'Este impresionante Mercedes-Benz GLE 53 AMG 2021 en negro metálico brillante es la definición de lujo deportivo. Cuenta con la icónica parrilla deportiva AMG, interior espectacular con asientos rojos y negros, llantas AMG negras, calipers de freno rojos, techo panorámico y tecnología de última generación. Ideal para ejecutivos y turistas VIP que buscan una experiencia de conducción excepcional.',
    passengers: 5,
    luggage: 4,
    fuel: 'Gasolina Premium',
    transmission: 'Automática AMG Speedshift',
    features: [
      'Parrilla deportiva AMG Panamericana',
      'Interior deportivo con asientos rojos y negros',
      'Volante deportivo AMG con levas',
      'Llantas AMG negras exclusivas',
      'Calipers de freno rojos AMG',
      'Techo panorámico amplio',
      'Pantalla digital Mercedes MBUX 12.3"',
      'Sistema de sonido Burmester premium',
      'Cámara 360 grados',
      'Asientos con memoria y masaje',
      'Climatización de 3 zonas',
      'Estribos laterales cromados',
      'Escapes deportivos dobles AMG',
      'AMG Performance exhaust',
      'Suspensión neumática adaptativa'
    ],
    specifications: {
      motor: 'V6 3.0L Biturbo',
      power: '429 HP',
      acceleration: '0-100 km/h en 5.3s',
      topSpeed: '250 km/h (limitada)'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto SDQ',
      'Asistencia VIP 24/7',
      'GPS navegación premium',
      'Tanque lleno de gasolina premium',
      'Vehículo de lujo en estado impecable'
    ],
    featured: true
  },
  {
    id: 'mercedes-gle-350-2022',
    name: 'Mercedes-Benz GLE 350',
    year: 2022,
    category: 'luxury',
    categoryLabel: 'Luxury',
    price: 260,
    images: [
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/59ntgiit_mercedes%20benz%20350%201.jpeg',
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/gag7iaoo_mercedes%20benz%20350%202.jpeg',
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/gvnqs5m4_mercedes%20benz%20350%203.jpeg',
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/3yu1kthw_mercedes%20benz%20350%204.jpeg',
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/7a5ay5f8_mercedes%20benz%20350%205.jpeg'
    ],
    mainImage: 'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/59ntgiit_mercedes%20benz%20350%201.jpeg',
    description: 'Mercedes-Benz GLE 350 2022 totalmente negro con techo de cielo estrellado LED, iluminación ambiental rosa/púrpura y paquete AMG Line. Elegancia alemana pura.',
    longDescription: 'Esta espectacular Mercedes-Benz GLE 350 2022 en negro brillante combina elegancia europea con tecnología de vanguardia. Cuenta con el paquete AMG Line que incluye la imponente parrilla Panamericana cromada, llantas negras deportivas multi-radio con calipers rojos, estribos laterales cromados y luces LED de diseño agresivo. El interior es una experiencia sensorial única: asientos de cuero negro premium con costuras contrastantes, volante deportivo con levas de cambio, tablero digital dual MBUX de extremo a extremo, y la exclusiva iluminación ambiental en tonos rosa y púrpura. Lo más impresionante es el exclusivo techo de cielo estrellado con cientos de luces LED que simulan las estrellas, creando una atmósfera mágica durante los viajes nocturnos. Perfecta para quienes buscan lujo alemán con detalles únicos.',
    passengers: 5,
    luggage: 4,
    fuel: 'Gasolina Premium',
    transmission: 'Automática 9G-TRONIC',
    features: [
      'Techo de cielo estrellado LED exclusivo',
      'Paquete AMG Line completo',
      'Parrilla Panamericana cromada',
      'Llantas negras deportivas multi-radio',
      'Calipers de freno rojos',
      'Iluminación ambiental rosa/púrpura',
      'Tablero digital dual MBUX',
      'Asientos de cuero negro con costuras contrastantes',
      'Volante deportivo con levas',
      'Estribos laterales cromados',
      'Sistema de sonido Burmester',
      'Cámara 360 grados',
      'Apple CarPlay / Android Auto',
      'Climatización automática de 3 zonas',
      'Asientos eléctricos con memoria',
      'Sensores de estacionamiento',
      'Luces LED inteligentes',
      'Mercedes Me Connect'
    ],
    specifications: {
      motor: '2.0L Turbo 4 cilindros',
      power: '255 HP',
      capacity: '5 pasajeros',
      consumption: '9.8 L/100km'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto',
      'Asistencia VIP 24/7',
      'GPS navegación premium',
      'Lujo alemán garantizado'
    ],
    featured: true
  },
  {
    id: 'chevrolet-tahoe-2024',
    name: 'Chevrolet Tahoe',
    year: 2024,
    category: 'premium',
    categoryLabel: 'Premium',
    price: 270,
    images: [
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/jlmeiurn_chevrolet%201.jpeg',
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/qnjhyo9q_chevrolet%202.jpeg',
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/32vdiihj_chevrolet%203.jpeg',
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/xzddi78b_chevrolet%204.jpeg'
    ],
    mainImage: 'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/jlmeiurn_chevrolet%201.jpeg',
    description: 'Chevrolet Tahoe 2024 en negro Midnight Edition. El SUV full-size más espacioso y lujoso de nuestra flota.',
    longDescription: 'Este impresionante Chevrolet Tahoe 2024 en negro brillante es el vehículo ideal para grupos grandes y familias que buscan máximo espacio y confort. Con capacidad para 7 pasajeros, asientos de cuero premium con costuras beige, tablero digital completo, pantalla táctil grande, techo panorámico y tecnología de última generación. Perfecto para viajes largos por toda la isla con máximo lujo y comodidad.',
    passengers: 7,
    luggage: 5,
    fuel: 'Gasolina',
    transmission: 'Automática',
    features: [
      'SUV full-size 7 pasajeros',
      'Asientos de cuero premium con costuras beige',
      'Tablero digital completo',
      'Pantalla táctil central grande',
      'Techo panorámico',
      'Luces LED modernas con DRL',
      'Llantas deportivas cromadas',
      'Estribos laterales cromados',
      'Asientos eléctricos con memoria',
      'Climatización de tres zonas',
      'Sistema de navegación GPS',
      'Control de crucero adaptativo',
      'Cámara de reversa HD',
      'Sensores de estacionamiento',
      'Puertos USB en todas las filas',
      'Sistema de entretenimiento trasero disponible',
      'Bluetooth y Apple CarPlay/Android Auto',
      'Maletero enorme',
      'Asientos capitán segunda fila'
    ],
    specifications: {
      motor: 'V8 5.3L',
      power: '355 HP',
      capacity: '7 pasajeros',
      cargo: '722 litros'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto',
      'Asistencia VIP 24/7',
      'GPS navegación',
      'Sillas para niños disponibles',
      'El SUV más grande de la flota'
    ],
    featured: true
  },
  {
    id: 'chevrolet-tahoe-rst-2023',
    name: 'Chevrolet Tahoe RST',
    year: 2023,
    category: 'premium',
    categoryLabel: 'Premium',
    price: 260,
    images: [
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/wmc1pmey_tahoe%20rst%201.jpeg',
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/10wpqcpb_tahoe%20rst%202.jpeg',
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/w9knseh1_tahoe%20rst%203.jpeg',
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/xhe3o0nd_tahoe%20rst%204.jpeg',
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/16qyi2hw_tahoe%20rst%205.jpeg'
    ],
    mainImage: 'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/wmc1pmey_tahoe%20rst%201.jpeg',
    description: 'Chevrolet Tahoe RST 2023 totalmente negra con techo de cielo estrellado LED y pantallas de entretenimiento traseras. Lujo extremo.',
    longDescription: 'Esta impresionante Chevrolet Tahoe RST 2023 es la versión más deportiva y exclusiva del icónico SUV americano. Completamente negra con el paquete RST que incluye parrilla negra brillante, llantas deportivas de alto rendimiento, y emblemas RST en rojo. El interior es espectacular: cuenta con un exclusivo techo de cielo estrellado con luces LED azules que simulan las estrellas, iluminación ambiental azul turquesa en todo el tablero, asientos de cuero premium negro, pantalla táctil central, y lo más impresionante: pantallas de entretenimiento individuales en los asientos traseros para los pasajeros. Perfecta para familias que buscan máximo lujo y tecnología.',
    passengers: 7,
    luggage: 5,
    fuel: 'Gasolina',
    transmission: 'Automática 10 velocidades',
    features: [
      'SUV full-size 7 pasajeros',
      'Techo de cielo estrellado LED exclusivo',
      'Pantallas de entretenimiento traseras individuales',
      'Iluminación ambiental azul turquesa',
      'Paquete RST deportivo completo',
      'Parrilla negra brillante',
      'Llantas deportivas negras premium',
      'Emblemas RST en rojo',
      'Asientos de cuero negro premium',
      'Pantalla táctil central grande',
      'Sistema de sonido Bose premium',
      'Climatización de tres zonas',
      'Apple CarPlay / Android Auto',
      'Cámara de reversa 360°',
      'Sensores de estacionamiento',
      'Control de crucero adaptativo',
      'Volante de cuero multifunción',
      'Asientos eléctricos con memoria',
      'Maletero enorme',
      'WiFi integrado',
      'Cargador inalámbrico'
    ],
    specifications: {
      motor: 'V8 5.3L EcoTec3',
      power: '355 HP',
      capacity: '7 pasajeros',
      cargo: '722 litros'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto',
      'Asistencia VIP 24/7',
      'GPS navegación',
      'Sillas para niños disponibles',
      'La Tahoe más exclusiva con cielo estrellado'
    ],
    featured: true
  },
  {
    id: 'jeep-gladiator-2023',
    name: 'Jeep Gladiator Rubicon',
    year: 2023,
    category: 'premium',
    categoryLabel: 'Premium',
    price: 220,
    images: [
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/kbwz9h4g_jeep%201.jpeg',
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/89urr76z_jeep%203.jpeg',
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/guyayg2i_jeep%204.jpeg',
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/ien5x7z6_jeep%205.jpeg',
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/qslaeq69_jeep%206.jpeg'
    ],
    mainImage: 'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/kbwz9h4g_jeep%201.jpeg',
    description: 'Jeep Gladiator Rubicon 2023 en negro con llantas off-road y interior deportivo con acentos rojos. La pickup más aventurera.',
    longDescription: 'El Jeep Gladiator Rubicon 2023 es la combinación perfecta entre la legendaria capacidad todoterreno de Jeep y la versatilidad de una pickup. Este impresionante vehículo en negro brillante cuenta con llantas off-road de alto rendimiento, suspensión elevada, interior premium con asientos de cuero negro con costuras rojas, tablero con acentos rojos distintivos, y la icónica parrilla de 7 ranuras de Jeep. Con capacidad para 5 pasajeros y una cama de carga espaciosa, es ideal para aventuras extremas y explorar cada rincón de República Dominicana.',
    passengers: 5,
    luggage: 4,
    fuel: 'Gasolina',
    transmission: 'Automática',
    features: [
      'Pickup 4x4 todoterreno',
      'Llantas off-road de alto rendimiento',
      'Suspensión Rubicon elevada',
      'Asientos de cuero negro con costuras rojas',
      'Tablero con acentos rojos deportivos',
      'Parrilla icónica Jeep de 7 ranuras',
      'Techo removible Freedom Top',
      'Ganchos de remolque rojos',
      'Sistema Uconnect con pantalla táctil',
      'Apple CarPlay / Android Auto',
      'Cámara de reversa HD',
      'Control de tracción 4x4',
      'Diferencial de bloqueo trasero',
      'Barras antivuelco',
      'Cama de carga con protector',
      'Bluetooth y USB',
      'Climatización automática',
      'Volante de cuero multifunción',
      'Trail Rated - certificado todoterreno'
    ],
    specifications: {
      motor: 'V6 3.6L Pentastar',
      power: '285 HP',
      capacity: '5 pasajeros',
      cargo: 'Cama de carga 5 pies'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto',
      'Asistencia 24/7',
      'GPS navegación',
      'Capacidad todoterreno extrema',
      'El Jeep más aventurero de la flota'
    ],
    featured: true
  },
  {
    id: 'honda-crv-2024-negra',
    name: 'Honda CR-V',
    year: 2024,
    category: 'suv',
    categoryLabel: 'SUV',
    price: 95,
    images: [
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/6rpxfb91_WhatsApp%20Image%202026-10-04%20at%2019.26.09.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/socz5aro_WhatsApp%20Image%202026-10-04%20at%2019.26.07.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/j9unjp7e_WhatsApp%20Image%202026-10-04%20at%2019.26.08.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/ykp4y0lt_WhatsApp%20Image%202026-10-04%20at%2019.26.07%20%281%29.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/drds6r1s_WhatsApp%20Image%202026-10-04%20at%2019.26.09%20%281%29.jpeg'
    ],
    mainImage: 'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/6rpxfb91_WhatsApp%20Image%202026-10-04%20at%2019.26.09.jpeg',
    description: 'Honda CR-V 2024 negra con espectacular interior rojo deportivo. Diseño agresivo con luces LED impresionantes y llantas negras con calipers rojos.',
    longDescription: 'Esta impactante Honda CR-V 2024 en negro brillante destaca por su espectacular interior con asientos de cuero rojo vibrante que la hacen única en nuestra flota. Fotografiada frente al mar Caribe, esta SUV cuenta con diseño exterior deportivo agresivo, parrilla negra cromada, luces LED modernas con firma luminosa distintiva, llantas negras deportivas con calipers rojos de alto rendimiento, estribos laterales cromados y sistema AWD. El interior es espectacular: asientos delanteros y traseros completamente tapizados en cuero rojo premium con costuras negras, volante multifunción, tablero digital, pantalla táctil con navegación GPS, climatización automática y amplias plazas traseras. Perfecta para quienes buscan estilo deportivo, tecnología moderna y un interior que impresiona.',
    passengers: 5,
    luggage: 3,
    fuel: 'Gasolina',
    transmission: 'Automática CVT',
    features: [
      'Interior deportivo con asientos de cuero ROJOS',
      'Asientos traseros también en cuero rojo premium',
      'Llantas negras deportivas con calipers ROJOS',
      'Luces LED espectaculares con firma luminosa',
      'Parrilla negra cromada deportiva',
      'Estribos laterales cromados',
      'Sistema AWD (tracción 4 ruedas)',
      'Tablero digital completo',
      'Pantalla táctil central con navegación GPS',
      'Volante deportivo multifunción',
      'Luces traseras LED modernas',
      'Honda Sensing (asistencias de conducción)',
      'Cámara trasera HD',
      'Climatización automática',
      'Bluetooth y USB-C',
      'Control de crucero adaptativo',
      'Apple CarPlay / Android Auto',
      'Diseño exterior agresivo'
    ],
    specifications: {
      motor: '1.5L Turbo AWD',
      power: '190 HP',
      capacity: '5 pasajeros',
      consumption: '7.8 L/100km'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto',
      'Asistencia 24/7',
      'El interior rojo más impactante',
      'Modelo 2024 con estilo deportivo'
    ],
    featured: true
  },
  {
    id: 'kia-sorento-2024',
    name: 'Kia Sorento',
    year: 2024,
    category: 'premium',
    categoryLabel: 'Premium',
    price: 85,
    images: [
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/rc94xntk_kia%2011.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/2g75mrov_kia%2014.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/qja12y1s_kia%2012.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/rzs6pyeo_kia%2013.jpeg'
    ],
    mainImage: 'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/rc94xntk_kia%2011.jpeg',
    description: 'Kia Sorento 2024 en blanco perlado con techo negro. SUV moderna y tecnológica, perfecta para familias.',
    longDescription: 'Esta impresionante Kia Sorento 2024 en blanco perlado con techo negro bicolor presenta el diseño más moderno de Kia con parrilla deportiva negra y llantas deportivas negras. Interior premium con 7 asientos de cuero negro, enorme techo panorámico, pantalla digital con iluminación morada, y tecnología de última generación. Perfecta para familias que buscan estilo, espacio y tecnología moderna a excelente precio.',
    passengers: 7,
    luggage: 4,
    fuel: 'Gasolina',
    transmission: 'Automática',
    features: [
      'Diseño bicolor blanco con techo negro',
      'Parrilla deportiva negra "Tiger Nose"',
      'Llantas deportivas negras',
      'Luces LED modernas',
      '7 asientos de cuero negro',
      'Techo panorámico enorme',
      'Pantalla digital con iluminación personalizable',
      'Volante deportivo multifunción',
      'Bluetooth y USB-C',
      'Cámara trasera HD',
      'Sensores de estacionamiento',
      'Control de crucero',
      'Climatización automática de tres zonas',
      'Apple CarPlay / Android Auto inalámbrico',
      'Estribos laterales cromados',
      'Segunda y tercera fila espaciosas',
      'Asientos eléctricos'
    ],
    specifications: {
      motor: '2.5L Turbo',
      power: '281 HP',
      capacity: '7 pasajeros',
      cargo: '498 litros'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto',
      'Asistencia 24/7',
      'GPS o mapa offline',
      'Modelo 2024 última generación'
    ]
  },
  {
    id: 'honda-crv-2025-hybrid',
    name: 'Honda CR-V Hybrid',
    year: 2025,
    category: 'suv',
    categoryLabel: 'SUV',
    price: 95,
    images: [
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/ky973iqu_2025%201%20.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/bkvpswx0_2025%202.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/8q3ki6of_2025%203.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/hd1uxfo9_2025%204.jpeg'
    ],
    mainImage: 'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/ky973iqu_2025%201%20.jpeg',
    description: 'Honda CR-V Hybrid 2025 en gris grafito. El modelo más nuevo con tecnología híbrida para máxima eficiencia.',
    longDescription: 'La nueva Honda CR-V Hybrid 2025 en color gris grafito metálico representa lo último en tecnología automotriz. Este modelo completamente renovado combina el motor híbrido de última generación para un consumo ultra eficiente, con un diseño exterior agresivo moderno, luces LED espectaculares, llantas negras deportivas, estribos cromados y un interior contemporáneo con asientos bicolor. Perfecta para turistas conscientes del medio ambiente que buscan tecnología de punta y ahorro en combustible.',
    passengers: 5,
    luggage: 3,
    fuel: 'Híbrido (Gasolina + Eléctrico)',
    transmission: 'Automática e-CVT',
    features: [
      'Tecnología Híbrida 2025 (Ultra eficiente)',
      'Diseño completamente nuevo 2025',
      'Parrilla hexagonal Honda moderna negra',
      'Luces LED con DRL espectaculares',
      'Luces traseras LED en forma de boomerang',
      'Llantas deportivas negras',
      'Estribos laterales cromados plateados',
      'Asientos bicolor (gris claro y oscuro)',
      'Pantalla táctil grande',
      'Tablero digital moderno',
      'Volante deportivo Honda',
      'Techo panorámico',
      'Escapes dobles cromados',
      'Honda Sensing (asistencias híbridas)',
      'Cámara trasera HD',
      'Climatización automática',
      'Bluetooth y USB-C',
      'Badge Hybrid exclusivo'
    ],
    specifications: {
      motor: '2.0L Híbrido',
      power: '204 HP (combinado)',
      capacity: '5 pasajeros',
      consumption: '5.3 L/100km (híbrido)'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto',
      'Asistencia 24/7',
      'Modelo 2025 más reciente',
      'Consumo ultra eficiente (híbrido)',
      'Tecnología de punta'
    ],
    featured: true
  },
  {
    id: 'hyundai-cantus-lux-2025',
    name: 'Hyundai Cantus Lux',
    year: 2025,
    category: 'suv',
    categoryLabel: 'SUV',
    price: 70,
    images: [
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/n40yfaht_cantux%20lux%201.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/v606u8no_cantux%20lux%202.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/pry2ovnb_cantux%20lux%203.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/8he7jev6_cantux%20lux%204.jpeg'
    ],
    mainImage: 'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/n40yfaht_cantux%20lux%201.jpeg',
    description: 'Hyundai Cantus Lux 2025 en negro brillante. SUV familiar moderna con 7 asientos y características premium.',
    longDescription: 'El nuevo Hyundai Cantus Lux 2025 en negro brillante combina espacio, tecnología y lujo a un precio excepcional. Equipado con mesa plegable en segunda fila, asientos bicolor premium (negro y gris claro), tablero digital completo, pantalla táctil grande y capacidad para 7 pasajeros. Ideal para familias grandes o grupos de amigos que buscan comodidad y funcionalidad moderna.',
    passengers: 7,
    luggage: 4,
    fuel: 'Gasolina',
    transmission: 'Automática',
    features: [
      'Mesa plegable en segunda fila',
      '7 pasajeros con amplio espacio',
      'Asientos bicolor premium (negro y gris)',
      'Tablero digital completo',
      'Pantalla táctil grande',
      'Parrilla deportiva Hyundai moderna',
      'Llantas deportivas bicolor',
      'Estribos laterales cromados',
      'Luces LED modernas',
      'Volante deportivo multifunción',
      'Climatización automática',
      'Techo panorámico',
      'Bluetooth y USB',
      'Cámara de reversa',
      'Sensores de estacionamiento',
      'Control de crucero',
      'Asientos de cuero/tela premium',
      'Espacio para equipaje familiar'
    ],
    specifications: {
      motor: '2.5L',
      power: '190 HP',
      capacity: '7 pasajeros',
      cargo: '550 litros'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto',
      'Asistencia 24/7',
      'Modelo 2025 más reciente',
      'Ideal para familias grandes'
    ]
  },
  {
    id: 'honda-crv-2024',
    name: 'Honda CR-V',
    year: 2024,
    category: 'suv',
    categoryLabel: 'SUV',
    price: 95,
    images: [
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/yctd7nq4_3.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/7tlifop0_1.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/uut84y25_2%20.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/pez2zubm_4.jpeg'
    ],
    mainImage: 'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/yctd7nq4_3.jpeg',
    description: 'Honda CR-V 2024 Sport, la última generación con diseño agresivo y moderno. Perfecta para familias que buscan estilo y tecnología.',
    longDescription: 'La nueva Honda CR-V 2024 en color blanco perla presenta un diseño completamente renovado con líneas deportivas y agresivas. Equipada con llantas negras deportivas, estribos laterales, techo panorámico y un interior moderno con asientos bicolor. Esta es la SUV perfecta para turistas que buscan lo último en tecnología y confort.',
    passengers: 5,
    luggage: 3,
    fuel: 'Gasolina',
    transmission: 'Automática CVT',
    features: [
      'Diseño Sport 2024 completamente nuevo',
      'Techo panorámico extra grande',
      'Llantas deportivas negras',
      'Pantalla táctil moderna',
      'Honda Sensing (asistencias de conducción)',
      'Cámara trasera HD',
      'Bluetooth y USB-C',
      'Climatización automática',
      'Asientos bicolor premium',
      'Estribos laterales cromados',
      'Parrilla deportiva negra',
      'Control de crucero adaptativo',
      'Alfombrillas AQUIRO personalizadas'
    ],
    specifications: {
      motor: '1.5L Turbo',
      power: '190 HP',
      capacity: '5 pasajeros',
      consumption: '7.8 L/100km'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto',
      'Asistencia 24/7',
      'Modelo 2024 más reciente',
      'Excelente consumo de combustible'
    ]
  },
  {
    id: 'honda-crv-2024-roja',
    name: 'Honda CR-V Sport',
    year: 2024,
    category: 'suv',
    categoryLabel: 'SUV',
    price: 95,
    images: [
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/vk82tjrl_crv%20roja%201.jpeg',
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/jfn28au6_crv%20roja%202.jpeg',
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/5mdrcsw9_crv%20roja%203.jpeg',
      'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/suc27pvg_crv%20roja%204.jpeg'
    ],
    mainImage: 'https://customer-assets.emergentagent.com/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/vk82tjrl_crv%20roja%201.jpeg',
    description: 'Honda CR-V Sport 2024 en rojo vibrante con llantas negras deportivas. Diseño agresivo con vista al mar del Caribe.',
    longDescription: 'Esta impresionante Honda CR-V Sport 2024 en color rojo vibrante es la combinación perfecta de estilo deportivo y funcionalidad. Equipada con llantas negras deportivas, estribos laterales cromados, techo panorámico enorme, interior premium con asientos de cuero bicolor (gris y negro), tablero digital moderno con pantalla táctil, y las exclusivas alfombrillas AQUIRO. Perfecta para turistas que buscan destacar con un vehículo llamativo mientras exploran República Dominicana.',
    passengers: 5,
    luggage: 3,
    fuel: 'Gasolina',
    transmission: 'Automática CVT',
    features: [
      'Color rojo vibrante exclusivo',
      'Llantas deportivas negras',
      'Estribos laterales cromados',
      'Techo panorámico enorme',
      'Interior de cuero bicolor (gris y negro)',
      'Tablero digital moderno',
      'Pantalla táctil central',
      'Alfombrillas AQUIRO personalizadas',
      'Honda Sensing (asistencias de conducción)',
      'Cámara trasera HD',
      'Bluetooth y USB-C',
      'Climatización automática',
      'Volante multifunción Honda',
      'Control de crucero adaptativo',
      'Parrilla deportiva negra',
      'Luces LED modernas',
      'Escapes dobles cromados'
    ],
    specifications: {
      motor: '1.5L Turbo',
      power: '190 HP',
      capacity: '5 pasajeros',
      consumption: '7.8 L/100km'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto',
      'Asistencia 24/7',
      'Modelo 2024 más reciente',
      'Excelente consumo de combustible'
    ],
    featured: true
  },
  {
    id: 'honda-crv-2022-roja',
    name: 'Honda CR-V Touring',
    year: 2022,
    category: 'suv',
    categoryLabel: 'SUV',
    price: 70,
    images: [
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/qm8d2a3h_crv%20roja%202022%2C%201.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/kxmbcamc_crv%20roja%202022%2C%202.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/no2u16bx_crv%20roja%202022%2C%203.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/0z505ryk_crv%20roja%202022%2C%204.jpeg'
    ],
    mainImage: 'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/qm8d2a3h_crv%20roja%202022%2C%201.jpeg',
    description: 'Honda CR-V Touring 2022 roja con interior bicolor beige y negro, techo panorámico gigante y detalles en madera. Elegancia y confort.',
    longDescription: 'Esta impresionante Honda CR-V Touring 2022 en rojo vibrante destaca por su interior premium bicolor con asientos de cuero beige y negro, acabados en madera auténtica, y un espectacular techo panorámico de gran tamaño que inunda de luz natural el habitáculo. Equipada con llantas de aleación plateadas, parrilla cromada elegante, estribos laterales y todas las características de la versión Touring: sistema de navegación, asientos con calefacción, cámara 360 grados y el confiable motor Honda. Perfecta para quienes buscan un SUV elegante con interior de lujo a un precio accesible.',
    passengers: 5,
    luggage: 3,
    fuel: 'Gasolina',
    transmission: 'Automática CVT',
    features: [
      'Interior bicolor beige y negro',
      'Asientos de cuero premium',
      'Acabados en madera auténtica',
      'Techo panorámico gigante',
      'Parrilla cromada elegante',
      'Llantas de aleación plateadas',
      'Estribos laterales',
      'Sistema de navegación',
      'Asientos con calefacción',
      'Cámara 360 grados',
      'Apple CarPlay / Android Auto',
      'Climatización automática de dos zonas',
      'Volante multifunción Honda',
      'Control de crucero adaptativo',
      'Sensores de estacionamiento',
      'Honda Sensing (asistencias)',
      'Bluetooth y USB',
      'Arranque sin llave'
    ],
    specifications: {
      motor: '1.5L Turbo',
      power: '190 HP',
      capacity: '5 pasajeros',
      consumption: '7.8 L/100km'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto',
      'Asistencia 24/7',
      'Interior de lujo incluido',
      'Excelente consumo de combustible'
    ],
    featured: false
  },
  {
    name: 'Honda CR-V',
    year: 2022,
    category: 'suv',
    categoryLabel: 'SUV',
    price: 70,
    images: [
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/f41ub0c6_cvr%202022%201.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/v4w5abkp_crv%202022%20%202.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/2n50s5rz_crv%202022%20%203.jpeg'
    ],
    mainImage: 'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/f41ub0c6_cvr%202022%201.jpeg',
    description: 'Honda CR-V 2022 blanca en excelente estado. Confiable, espaciosa y económica, perfecta para recorrer la isla.',
    longDescription: 'Este Honda CR-V 2022 en color blanco perlado está en condiciones impecables. Cuenta con techo panorámico, llantas deportivas bicolor, estribos laterales y un interior moderno con detalles en madera. Perfecta para turistas que buscan comodidad, confiabilidad y un excelente precio.',
    passengers: 5,
    luggage: 3,
    fuel: 'Gasolina',
    transmission: 'Automática',
    features: [
      'Techo panorámico',
      'Pantalla táctil con sistema de audio',
      'Bluetooth y USB',
      'Cámara trasera',
      'Aire acondicionado',
      'Volante multifunción',
      'Asientos con detalles premium',
      'Llantas deportivas bicolor',
      'Estribos laterales',
      'Visores de lluvia',
      'Control de crucero',
      'Alfombrillas personalizadas'
    ],
    specifications: {
      motor: '2.4L',
      power: '184 HP',
      capacity: '5 pasajeros',
      consumption: '8.5 L/100km'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto',
      'Asistencia 24/7',
      'Vehículo limpio y desinfectado'
    ]
  },
  {
    id: 'toyota-rav4-2019',
    name: 'Toyota RAV4',
    year: 2019,
    category: 'suv',
    categoryLabel: 'SUV',
    price: 65,
    images: [
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/cq9soxai_9.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/bgmekh3r_10.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/zbrzn86q_11.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/r7mu0e11_12.jpeg'
    ],
    mainImage: 'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/cq9soxai_9.jpeg',
    description: 'Toyota RAV4 2019 en color rojo vibrante. La confiabilidad Toyota a precio accesible.',
    longDescription: 'Esta Toyota RAV4 2019 en impactante color rojo es la combinación perfecta de confiabilidad, comodidad y precio accesible. Equipada con llantas deportivas plateadas, estribos laterales, visores de lluvia y un interior moderno con asientos bicolor. Ideal para parejas o familias pequeñas que buscan un SUV confiable para explorar República Dominicana sin gastar de más.',
    passengers: 5,
    luggage: 3,
    fuel: 'Gasolina',
    transmission: 'Automática',
    features: [
      'Diseño moderno con luces LED',
      'Llantas deportivas plateadas',
      'Estribos laterales cromados',
      'Visores de lluvia',
      'Pantalla táctil central',
      'Aire acondicionado',
      'Radio y Bluetooth',
      'Asientos bicolor (negro y gris)',
      'Volante multifunción Toyota',
      'Puerto USB',
      'Cómodos asientos de tela premium',
      'Maletero amplio',
      'Bajo consumo de combustible',
      'Fácil de conducir',
      'Excelente visibilidad'
    ],
    specifications: {
      motor: '2.5L',
      power: '176 HP',
      capacity: '5 pasajeros',
      consumption: '7.9 L/100km'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto',
      'Asistencia 24/7',
      'Vehículo económico y confiable'
    ]
  },
  {
    id: 'kia-sorento-2019',
    name: 'Kia Sorento',
    year: 2019,
    category: 'suv',
    categoryLabel: 'SUV',
    price: 65,
    images: [
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/fkzga670_kia%201.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/mzxt8z08_kia%202.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/mnh14b89_kia%203.jpeg'
    ],
    mainImage: 'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/fkzga670_kia%201.jpeg',
    description: 'Kia Sorento 2019 en negro elegante. Espaciosa con 7 asientos a precio económico.',
    longDescription: 'Esta Kia Sorento 2019 en color negro/gris oscuro ofrece espacio para 7 pasajeros a un precio muy accesible. Equipada con llantas deportivas plateadas, estribos laterales cromados, pantalla táctil y alfombrillas AQUIRO personalizadas. Perfecta para familias grandes o grupos de amigos que viajan juntos y buscan economía sin sacrificar espacio.',
    passengers: 7,
    luggage: 4,
    fuel: 'Gasolina',
    transmission: 'Automática',
    features: [
      '7 pasajeros cómodamente',
      'Tercera fila de asientos',
      'Llantas deportivas plateadas',
      'Estribos laterales cromados',
      'Pantalla táctil',
      'Volante multifunción Kia',
      'Aire acondicionado',
      'Bluetooth',
      'Alfombrillas AQUIRO personalizadas',
      'Asientos de cuero/tela premium',
      'Maletero espacioso',
      'Fácil acceso tercera fila',
      'Ideal para grupos grandes'
    ],
    specifications: {
      motor: '2.4L',
      power: '185 HP',
      capacity: '7 pasajeros',
      cargo: '466 litros'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto',
      'Asistencia 24/7',
      '7 pasajeros a precio económico'
    ]
  },
  {
    id: 'honda-crv-2020',
    name: 'Honda CR-V',
    year: 2020,
    category: 'suv',
    categoryLabel: 'SUV',
    price: 65,
    images: [
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/0zb2lsjb_13.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/u1gvtl55_14.jpeg',
      'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/ktt9m3hv_15.jpeg'
    ],
    mainImage: 'https://customer-assets.emergentagent.com/job_auto-turismo-rd/artifacts/0zb2lsjb_13.jpeg',
    description: 'Honda CR-V 2020 en color plata elegante. La opción más económica sin comprometer calidad Honda.',
    longDescription: 'Esta Honda CR-V 2020 en color plata metálico es nuestra opción más económica manteniendo los altos estándares de calidad Honda. Equipada con llantas deportivas bicolor, techo panorámico, interior con detalles en madera y alfombrillas AQUIRO personalizadas. Perfecta para parejas o grupos pequeños que buscan confiabilidad y economía.',
    passengers: 5,
    luggage: 3,
    fuel: 'Gasolina',
    transmission: 'Automática',
    features: [
      'Techo panorámico',
      'Llantas deportivas bicolor',
      'Pantalla táctil central',
      'Interior con detalles en madera',
      'Aire acondicionado',
      'Bluetooth y USB',
      'Volante multifunción Honda',
      'Alfombrillas AQUIRO personalizadas',
      'Asientos cómodos',
      'Parrilla cromada elegante',
      'Compacta y fácil de estacionar',
      'Bajo consumo de combustible',
      'Maletero espacioso',
      'Excelente visibilidad'
    ],
    specifications: {
      motor: '2.4L',
      power: '184 HP',
      capacity: '5 pasajeros',
      consumption: '8.7 L/100km'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto',
      'Asistencia 24/7',
      'Mejor precio del catálogo'
    ]
  },
  {
    id: 'honda-crv-2016',
    name: 'Honda CR-V EX-L',
    year: 2016,
    category: 'suv',
    categoryLabel: 'SUV',
    price: 50,
    images: [
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/16sj1glp_WhatsApp%20Image%202026-08-30%20at%2016.33.12.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/e5wsthsl_WhatsApp%20Image%202026-08-30%20at%2016.33.12%20%281%29.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/z90k6q62_WhatsApp%20Image%202026-08-30%20at%2016.33.13.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/8y17jpe4_WhatsApp%20Image%202026-08-30%20at%2016.33.13%20%281%29.jpeg'
    ],
    mainImage: 'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/16sj1glp_WhatsApp%20Image%202026-08-30%20at%2016.33.12.jpeg',
    description: 'Honda CR-V EX-L 2016 blanca en excelente estado. El precio más económico de toda la flota con calidad Honda garantizada.',
    longDescription: 'Esta Honda CR-V EX-L 2016 en blanco perla es la opción perfecta para quienes buscan el mejor precio sin sacrificar comodidad y confiabilidad. Equipada con tracción AWD (4x4), motor 2.4L i-VTEC de 185 HP, asientos de cuero negro premium, techo solar, pantalla táctil con sistema de navegación, estribos laterales elegantes y llantas de aleación. Es el vehículo más económico de nuestra flota pero mantiene los altos estándares de calidad y confiabilidad que caracterizan a Honda. Ideal para turistas que desean explorar República Dominicana con un presupuesto ajustado.',
    passengers: 5,
    luggage: 3,
    fuel: 'Gasolina',
    transmission: 'Automática CVT',
    features: [
      'Tracción AWD (4x4)',
      'Asientos de cuero negro premium',
      'Techo solar eléctrico',
      'Pantalla táctil con navegación',
      'Motor i-VTEC 2.4L eficiente',
      'Estribos laterales elegantes',
      'Llantas de aleación',
      'Cámara de reversa',
      'Bluetooth y USB',
      'Climatización automática',
      'Volante multifunción Honda',
      'Control de crucero',
      'Sistema de audio premium',
      'Faros antiniebla',
      'Excelente consumo de combustible',
      'Vehículo comprobado y confiable'
    ],
    specifications: {
      motor: '2.4L i-VTEC',
      power: '185 HP',
      capacity: '5 pasajeros',
      consumption: '9.0 L/100km'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto',
      'Asistencia 24/7',
      'El precio más bajo de la flota',
      'Calidad Honda garantizada'
    ]
  },
  {
    id: 'honda-crv-2016-gris',
    name: 'Honda CR-V EX',
    year: 2016,
    category: 'suv',
    categoryLabel: 'SUV',
    price: 50,
    images: [
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/boqp0s90_crv%202016%20gris%201.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/5bexxakw_crv%202016%20gris%202.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/67e1i1xa_crv%202016%20gris%203.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/pfx66j5z_crv%202016%20gris%204.jpeg'
    ],
    mainImage: 'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/boqp0s90_crv%202016%20gris%201.jpeg',
    description: 'Honda CR-V EX 2016 gris oscuro con interior bicolor beige y negro, techo solar y vista al mar caribeño. Económica y confiable.',
    longDescription: 'Esta elegante Honda CR-V EX 2016 en gris oscuro metálico ofrece el balance perfecto entre precio y calidad. Con un hermoso interior bicolor en beige y negro, amplio techo solar que ilumina el habitáculo, estribos laterales elegantes, llantas de aleación plateadas y la icónica parrilla cromada Honda. Fotografiada frente al mar Caribe, este vehículo representa la confiabilidad Honda a un precio imbatible. Perfecta para turistas que buscan explorar República Dominicana con comodidad sin gastar de más.',
    passengers: 5,
    luggage: 3,
    fuel: 'Gasolina',
    transmission: 'Automática CVT',
    features: [
      'Interior bicolor beige y negro',
      'Techo solar eléctrico',
      'Estribos laterales elegantes',
      'Llantas de aleación plateadas',
      'Parrilla cromada Honda',
      'Pantalla táctil central',
      'Cámara de reversa',
      'Bluetooth y USB',
      'Climatización automática',
      'Volante multifunción Honda',
      'Control de crucero',
      'Faros antiniebla LED',
      'Spoiler trasero deportivo',
      'Espejos eléctricos',
      'Amplio espacio interior',
      'Excelente consumo de combustible'
    ],
    specifications: {
      motor: '2.4L i-VTEC',
      power: '185 HP',
      capacity: '5 pasajeros',
      consumption: '9.0 L/100km'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto',
      'Asistencia 24/7',
      'El precio más económico de la flota',
      'Calidad Honda garantizada'
    ]
  },
  {
    id: 'kia-optima-2018',
    name: 'Kia Optima LX',
    year: 2018,
    category: 'sedan',
    categoryLabel: 'Sedán',
    price: 35,
    images: [
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/jspyiq40_kia%20optima%201.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/31kcoduz_kia%20optima%202.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/p0ii4c0n_kia%20optima%203.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/vtfrhdr0_kia%20optima%204.jpeg'
    ],
    mainImage: 'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/jspyiq40_kia%20optima%201.jpeg',
    description: 'Kia Optima LX 2018 negro elegante con vista al mar Caribe. El sedán más económico de la flota, perfecto para moverse con estilo.',
    longDescription: 'Este elegante Kia Optima LX 2018 en negro brillante es la opción más económica de nuestra flota sin sacrificar estilo ni confort. Con su diseño aerodinámico europeo, parrilla característica de Kia con acabado tipo panal, faros LED con líneas deportivas, llantas de aleación plateadas y líneas de carrocería fluidas. El interior cuenta con asientos bicolor gris claro y negro, volante multifunción, pantalla táctil con bluetooth, amplio espacio para 5 pasajeros y excelente visibilidad. Fotografiado frente al mar Caribe, este sedán es perfecto para turistas que buscan economía, confort y un vehículo confiable para explorar República Dominicana.',
    passengers: 5,
    luggage: 3,
    fuel: 'Gasolina',
    transmission: 'Automática',
    features: [
      'Sedán ejecutivo elegante',
      'Diseño aerodinámico europeo',
      'Parrilla tipo panal característica',
      'Faros LED con líneas deportivas',
      'Llantas de aleación plateadas',
      'Interior bicolor gris y negro',
      'Pantalla táctil central',
      'Bluetooth y USB',
      'Volante multifunción',
      'Climatización automática',
      'Control de crucero',
      'Cámara de reversa',
      'Amplio maletero',
      'Excelente consumo de combustible',
      'Fácil de manejar y estacionar',
      'Cristales tintados'
    ],
    specifications: {
      motor: '2.4L GDI',
      power: '185 HP',
      capacity: '5 pasajeros',
      consumption: '7.8 L/100km'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto',
      'Asistencia 24/7',
      'El precio más bajo de toda la flota',
      'Sedán cómodo y económico'
    ]
  },
  {
    id: 'honda-civic-2020',
    name: 'Honda Civic',
    year: 2020,
    category: 'sedan',
    categoryLabel: 'Sedán',
    price: 45,
    images: [
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/lipld8wp_WhatsApp%20Image%202026-08-30%20at%2021.29.50.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/qp2ftcla_WhatsApp%20Image%202026-08-30%20at%2021.29.50%20%281%29.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/9zfo4db4_WhatsApp%20Image%202026-08-30%20at%2021.29.50%20%282%29.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/jvwwd3cg_WhatsApp%20Image%202026-08-30%20at%2021.29.51.jpeg'
    ],
    mainImage: 'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/lipld8wp_WhatsApp%20Image%202026-08-30%20at%2021.29.50.jpeg',
    description: 'Honda Civic 2020 en negro brillante con diseño deportivo agresivo, llantas de aleación y vista al mar Caribe. Elegante y económico.',
    longDescription: 'Este elegante Honda Civic 2020 en negro brillante es la combinación perfecta de estilo deportivo, eficiencia y economía. Cuenta con un diseño exterior agresivo con líneas aerodinámicas, parrilla frontal negra deportiva, luces LED con DRL, llantas de aleación bicolor de estilo turbina, y un spoiler trasero integrado que le da un toque de deportividad. El interior es igualmente impresionante: volante deportivo forrado en cuero con marca roja característica, tablero digital con velocímetro central, pantalla táctil de 7" con Apple CarPlay y Android Auto, asientos de tela premium negros, y climatización automática. Fotografiado frente al mar Caribe, este sedán es perfecto para parejas o viajeros que buscan un vehículo elegante, confiable y económico para explorar República Dominicana.',
    passengers: 5,
    luggage: 3,
    fuel: 'Gasolina',
    transmission: 'Automática CVT',
    features: [
      'Diseño deportivo exterior agresivo',
      'Color negro brillante elegante',
      'Llantas de aleación bicolor estilo turbina',
      'Luces LED con DRL',
      'Spoiler trasero integrado',
      'Parrilla frontal deportiva negra',
      'Volante deportivo con marca roja',
      'Tablero digital con velocímetro central',
      'Pantalla táctil 7" Honda',
      'Apple CarPlay / Android Auto',
      'Cámara de reversa',
      'Bluetooth y USB',
      'Climatización automática',
      'Honda Sensing (asistencias de conducción)',
      'Control de crucero',
      'Arranque sin llave',
      'Cristales tintados',
      'Excelente consumo de combustible',
      'Fácil de manejar y estacionar'
    ],
    specifications: {
      motor: '2.0L i-VTEC',
      power: '158 HP',
      capacity: '5 pasajeros',
      consumption: '6.8 L/100km'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto',
      'Asistencia 24/7',
      'El sedán más elegante a precio económico',
      'Confiabilidad Honda garantizada'
    ]
  },
  {
    id: 'honda-crv-2021-negra',
    name: 'Honda CR-V',
    year: 2021,
    category: 'suv',
    categoryLabel: 'SUV',
    price: 65,
    images: [
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/6rgl4x9t_WhatsApp%20Image%202026-09-06%20at%2023.31.15.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/pblqkebx_WhatsApp%20Image%202026-09-06%20at%2023.31.16.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/h06oixk8_WhatsApp%20Image%202026-09-06%20at%2023.31.16%20%281%29.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/e5gf0kks_WhatsApp%20Image%202026-09-06%20at%2023.31.16%20%282%29.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/z1ed715m_WhatsApp%20Image%202026-09-06%20at%2023.31.16%20%283%29.jpeg'
    ],
    mainImage: 'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/6rgl4x9t_WhatsApp%20Image%202026-09-06%20at%2023.31.15.jpeg',
    description: 'Honda CR-V 2021 en negro brillante con estribos laterales cromados, interior elegante con detalles en madera y vista al mar Caribe.',
    longDescription: 'Esta elegante Honda CR-V 2021 en negro brillante es la combinación perfecta de estilo, comodidad y confiabilidad Honda. Cuenta con un diseño exterior moderno con parrilla cromada, luces LED con firma luminosa distintiva, estribos laterales cromados y llantas de aleación bicolor deportivas. El interior es sofisticado y acogedor: tablero con acabados en madera auténtica, volante multifunción forrado en cuero, pantalla táctil central, tablero digital, asientos de tela premium negros y climatización automática. Fotografiada frente al mar Caribe, esta SUV es perfecta para familias o grupos pequeños que buscan un vehículo confiable, cómodo y económico para explorar República Dominicana.',
    passengers: 5,
    luggage: 3,
    fuel: 'Gasolina',
    transmission: 'Automática CVT',
    features: [
      'Color negro brillante elegante',
      'Estribos laterales cromados',
      'Parrilla cromada Honda',
      'Luces LED con firma luminosa',
      'Llantas de aleación bicolor',
      'Interior con acabados en madera auténtica',
      'Volante multifunción de cuero',
      'Tablero digital',
      'Pantalla táctil central 7"',
      'Apple CarPlay / Android Auto',
      'Cámara de reversa',
      'Bluetooth y USB',
      'Climatización automática',
      'Honda Sensing (asistencias de conducción)',
      'Control de crucero adaptativo',
      'Sensores de estacionamiento',
      'Asientos de tela premium',
      'Amplias plazas traseras',
      'Maletero espacioso',
      'Excelente consumo de combustible'
    ],
    specifications: {
      motor: '1.5L Turbo',
      power: '190 HP',
      capacity: '5 pasajeros',
      consumption: '7.8 L/100km'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto',
      'Asistencia 24/7',
      'SUV elegante a precio accesible',
      'Confiabilidad Honda garantizada'
    ]
  },
  {
    id: 'honda-crv-2020-plata',
    name: 'Honda CR-V',
    year: 2020,
    category: 'suv',
    categoryLabel: 'SUV',
    price: 60,
    images: [
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/7gczhuiq_WhatsApp%20Image%202026-09-07%20at%2000.12.33.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/mgos6z60_WhatsApp%20Image%202026-09-07%20at%2000.12.34.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/voy65a5r_WhatsApp%20Image%202026-09-07%20at%2000.12.34%20%281%29.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/neyl8kcz_WhatsApp%20Image%202026-09-07%20at%2000.12.34%20%282%29.jpeg'
    ],
    mainImage: 'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/7gczhuiq_WhatsApp%20Image%202026-09-07%20at%2000.12.33.jpeg',
    description: 'Honda CR-V 2020 en plata elegante con estribos laterales, llantas de aleación deportivas y sistema AWD. Interior premium con detalles en madera.',
    longDescription: 'Esta impecable Honda CR-V 2020 en color plata lunar combina elegancia, potencia y comodidad en un solo paquete. Equipada con sistema AWD (tracción en las 4 ruedas), es perfecta para cualquier terreno de República Dominicana. El exterior destaca por sus líneas aerodinámicas modernas, parrilla cromada Honda, luces LED con firma distintiva, estribos laterales, faros antiniebla y llantas de aleación deportivas. El interior es un oasis de confort: volante multifunción forrado en cuero, tablero digital de última generación, pantalla táctil central con Apple CarPlay y Android Auto, acabados en madera auténtica, asientos de cuero negro premium, climatización automática de doble zona y amplio espacio para pasajeros y equipaje. Fotografiada frente al mar Caribe al atardecer, esta SUV es ideal para familias o grupos que buscan estilo, seguridad y rendimiento.',
    passengers: 5,
    luggage: 4,
    fuel: 'Gasolina',
    transmission: 'Automática CVT',
    features: [
      'Color plata lunar elegante',
      'Sistema AWD (tracción 4 ruedas)',
      'Estribos laterales cromados',
      'Parrilla cromada Honda distintiva',
      'Luces LED con firma luminosa',
      'Faros antiniebla integrados',
      'Llantas de aleación deportivas',
      'Interior con acabados en madera auténtica',
      'Volante multifunción de cuero',
      'Tablero digital de última generación',
      'Pantalla táctil central 7"',
      'Apple CarPlay / Android Auto',
      'Cámara de reversa HD',
      'Bluetooth y USB',
      'Climatización automática doble zona',
      'Honda Sensing (asistencias de conducción)',
      'Control de crucero adaptativo',
      'Sensores de estacionamiento',
      'Asientos de cuero negro premium',
      'Amplias plazas traseras',
      'Maletero espacioso',
      'Excelente consumo de combustible'
    ],
    specifications: {
      motor: '1.5L Turbo AWD',
      power: '190 HP',
      capacity: '5 pasajeros',
      consumption: '8.2 L/100km'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto',
      'Asistencia 24/7',
      'SUV con tracción AWD a precio accesible',
      'Confiabilidad Honda garantizada'
    ]
  },
  {
    id: 'toyota-rav4-2025',
    name: 'Toyota RAV4',
    year: 2025,
    category: 'suv',
    categoryLabel: 'SUV',
    price: 80,
    images: [
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/idvs41fz_WhatsApp%20Image%202026-10-04%20at%2019.26.07%20%282%29.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/5fxqoc4k_WhatsApp%20Image%202026-10-04%20at%2019.26.08%20%281%29.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/xwazizv1_WhatsApp%20Image%202026-10-04%20at%2019.26.07%20%283%29.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/xriwgmjo_WhatsApp%20Image%202026-10-04%20at%2019.26.08%20%282%29.jpeg'
    ],
    mainImage: 'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/idvs41fz_WhatsApp%20Image%202026-10-04%20at%2019.26.07%20%282%29.jpeg',
    description: 'Toyota RAV4 2025 blanca con llantas negras deportivas. La competencia directa de la Honda CR-V con la legendaria confiabilidad Toyota.',
    longDescription: 'Esta impresionante Toyota RAV4 2025 en blanco perla es la competencia directa de la Honda CR-V, ofreciendo la legendaria confiabilidad Toyota combinada con un diseño moderno y agresivo. Fotografiada frente al mar Caribe al atardecer, esta SUV destaca por su diseño exterior robusto con parrilla negra hexagonal, luces LED afiladas con firma luminosa distintiva, guardabarros ensanchados negros que le dan un aspecto aventurero, y espectaculares llantas negras deportivas de diseño turbina. El interior es igualmente impresionante: tablero con instrumentos analógicos y digitales, pantalla táctil central con cámara de reversa, volante multifunción con logo Toyota, palanca de cambios deportiva con iluminación LED azul, climatización automática y asientos de tela premium en tonos grises. Perfecta para quienes buscan una SUV confiable, moderna y con presencia imponente para explorar República Dominicana.',
    passengers: 5,
    luggage: 4,
    fuel: 'Gasolina',
    transmission: 'Automática',
    features: [
      'Competencia directa de la Honda CR-V',
      'Legendaria confiabilidad Toyota',
      'Color blanco perla elegante',
      'Llantas negras deportivas estilo turbina',
      'Parrilla negra hexagonal agresiva',
      'Luces LED con firma luminosa afilada',
      'Guardabarros ensanchados negros',
      'Diseño exterior robusto y aventurero',
      'Tablero con instrumentos analógicos y digitales',
      'Pantalla táctil central 8"',
      'Cámara de reversa HD',
      'Volante multifunción Toyota',
      'Palanca de cambios con LED azul',
      'Climatización automática',
      'Toyota Safety Sense (asistencias de conducción)',
      'Control de crucero adaptativo',
      'Bluetooth y USB',
      'Apple CarPlay / Android Auto',
      'Asientos de tela premium grises',
      'Amplio maletero',
      'Excelente consumo de combustible'
    ],
    specifications: {
      motor: '2.5L Dynamic Force',
      power: '203 HP',
      capacity: '5 pasajeros',
      consumption: '7.6 L/100km'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto',
      'Asistencia 24/7',
      'La rival de la CR-V con sello Toyota',
      'Modelo 2025 más reciente'
    ]
  },
  {
    id: 'honda-crv-2025-hybrid-azul',
    name: 'Honda CR-V Hybrid',
    year: 2025,
    category: 'suv',
    categoryLabel: 'SUV Híbrida',
    price: 95,
    images: [
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/c19jbw2i_WhatsApp%20Image%202026-10-04%20at%2019.26.09%20%282%29.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/c2h05a7z_WhatsApp%20Image%202026-10-04%20at%2019.26.07%20%284%29.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/he688g97_WhatsApp%20Image%202026-10-04%20at%2019.26.08%20%283%29.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/o94di2g1_WhatsApp%20Image%202026-10-04%20at%2019.26.09%20%283%29.jpeg',
      'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/7xkj9oss_WhatsApp%20Image%202026-10-04%20at%2019.26.09%20%284%29.jpeg'
    ],
    mainImage: 'https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/c19jbw2i_WhatsApp%20Image%202026-10-04%20at%2019.26.09%20%282%29.jpeg',
    description: 'Honda CR-V Hybrid 2025 azul oscuro con tecnología híbrida y consumo ultra bajo de solo 5.5 L/100km. Ahorra hasta un 40% en combustible.',
    longDescription: 'Esta impresionante Honda CR-V Hybrid 2025 en azul oscuro metalizado representa la combinación perfecta de rendimiento, tecnología y AHORRO EN COMBUSTIBLE. Gracias a su sistema híbrido de última generación, consume solo 5.5 L/100km - hasta un 40% menos que una SUV convencional. Fotografiada al atardecer frente al mar Caribe, esta SUV destaca por su diseño exterior deportivo agresivo con parrilla negra cromada, espectaculares luces LED diurnas en forma de flecha, guardabarros ensanchados negros, elegantes llantas negras deportivas de diseño turbina, y el distintivo badge "AWD" que indica tracción en las 4 ruedas. El interior es lujoso y moderno: asientos de cuero negro premium con costuras rojas deportivas, volante multifunción forrado en cuero con logo Honda, tablero digital con indicador de carga híbrida, pantalla táctil central con Apple CarPlay y Android Auto, climatización automática con salidas traseras independientes, y amplias plazas traseras con asientos reclinables. Perfecta para quienes buscan AHORRAR EN COMBUSTIBLE sin sacrificar potencia, tecnología ni el confort de una SUV premium.',
    passengers: 5,
    luggage: 4,
    fuel: 'Híbrido (Gasolina + Eléctrico)',
    transmission: 'Automática e-CVT',
    features: [
      'TECNOLOGÍA HÍBRIDA - Ahorro hasta 40% en combustible',
      'Consumo ultra bajo: solo 5.5 L/100km',
      'Motor híbrido 2.0L + motor eléctrico',
      'Sistema AWD (tracción 4 ruedas)',
      'Color azul oscuro metalizado elegante',
      'Llantas negras deportivas estilo turbina',
      'Parrilla negra cromada deportiva',
      'Luces LED diurnas en forma de flecha',
      'Luces traseras LED modernas',
      'Guardabarros ensanchados negros',
      'Asientos de cuero negro con costuras ROJAS',
      'Asientos traseros con costuras rojas',
      'Tablero digital con indicador híbrido',
      'Pantalla táctil central 9"',
      'Apple CarPlay / Android Auto',
      'Climatización automática con salidas traseras',
      'Volante multifunción de cuero',
      'Honda Sensing (asistencias de conducción)',
      'Cámara de reversa HD',
      'Control de crucero adaptativo',
      'Modo ECO para máximo ahorro',
      'Regeneración de energía al frenar'
    ],
    specifications: {
      motor: '2.0L Hybrid + Motor Eléctrico',
      power: '204 HP combinados',
      capacity: '5 pasajeros',
      consumption: '5.5 L/100km (AHORRO 40%)'
    },
    included: [
      'Seguro de ley incluido',
      'Entrega gratis en aeropuerto',
      'Asistencia 24/7',
      'AHORRA hasta 40% en combustible',
      'Tecnología híbrida Honda de última generación'
    ],
    featured: true
  }
];

// Helper functions
export const getVehicleById = (id) => {
  return vehiclesData.find(vehicle => vehicle.id === id);
};

export const getVehiclesByCategory = (category) => {
  if (category === 'all') return vehiclesData;
  return vehiclesData.filter(vehicle => vehicle.category === category);
};

export const getFeaturedVehicles = () => {
  return vehiclesData.filter(vehicle => vehicle.featured);
};

export const categories = [
  { id: 'all', name: 'Todos', count: vehiclesData.length },
  { id: 'luxury', name: 'Luxury', count: vehiclesData.filter(v => v.category === 'luxury').length },
  { id: 'premium', name: 'Premium', count: vehiclesData.filter(v => v.category === 'premium').length },
  { id: 'suv', name: 'SUV', count: vehiclesData.filter(v => v.category === 'suv').length },
  { id: 'sedan', name: 'Sedán', count: vehiclesData.filter(v => v.category === 'sedan').length }
];
